import React from 'react';
import PropTypes from 'prop-types';
import FormsyForm from 'epic-diesel-form/src/components/external/FormsyForm';
import {Button, buttonTypes, priority} from 'epic-diesel-common/src';
import {getLocale} from "epic-common/src/locale";


import styles from './Tax.pcss';
import Message from '../common/Message';

const Consent = ({isConsent, consentForPayment}) => {
    if (isConsent) {
        return null;
    }

    const submitForm = () => {
        const locale = getLocale();
        consentForPayment({locale});
    };

    return (
        <div className={styles.section}>
            <div className={styles.title}>
                <Message code="epic.affiliate.common.submit.consent" />
            </div>
            <div className={styles.desc}>
                <Message code="label.affiliate.form.tax.consent.desc" />
            </div>
            <FormsyForm submitForm={submitForm}>
                <div className={styles.row}>
                    <Button type={buttonTypes.SUBMIT} priority={priority.PRIMARY} theme="dark">
                        <Message code="epic.affiliate.common.submit.consent" />
                    </Button>
                </div>
            </FormsyForm>
        </div>
    );
};

Consent.propTypes = {
    messages: PropTypes.object,
    isConsent: PropTypes.bool,
    consentForPayment: PropTypes.func
};

export default Consent;
